import packageEnv from '../package.json';
import { envType } from './serverType';
// main server controller

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  currentEnv: envType(packageEnv.env),
};
